import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	body: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		minHeight: 0,
		padding: `${THEME.spacing.md}px ${THEME.spacing.md}px 0`,
	},
	filterInput: {
		width: '100%',
	},
	list: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		minHeight: 0,
		overflowY: 'auto',
	},
	row: {
		alignItems: 'center',
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		cursor: 'pointer',
		display: 'flex',
		gap: THEME.spacing.sm,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.xs}px`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	rowPill: {
		flex: 1,
		minWidth: 0,
	},
	contactCount: {
		color: THEME.colors.text.light,
		flexShrink: 0,
		fontSize: THEME.typography.fontSizes.xs,
		fontVariantNumeric: 'tabular-nums',
	},
	skeletonRow: {
		height: 36,
		marginBottom: THEME.spacing.xs,
	},
	message: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		padding: `${THEME.spacing.lg}px 0`,
		textAlign: 'center',
	},
	loadingMore: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		padding: `${THEME.spacing.sm}px 0`,
		textAlign: 'center',
	},
	footer: {
		borderTop: `1px solid ${THEME.colors.border.light}`,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingTop: THEME.spacing.md,
	},
});
